import { Spinner } from '../../../components/spinner/spinner';
import { ProcessCheckout } from '../checkout-view';
import useQuote from './hooks/use-quote';

export const QuoteView = ({ orderId }: { orderId: number }) => {
  const { order, location, cart, isSubmitting, summary, onSubmit, handleDeliveryAddressChange } = useQuote(orderId);

  return !order || !location || !cart ? (
    <Spinner />
  ) : (
    <ProcessCheckout
      isQuote
      cart={cart}
      fetchCart={async () => {}}
      location={location}
      summary={summary}
      isSubmitting={isSubmitting}
      onSubmit={onSubmit}
      customCalculation={handleDeliveryAddressChange}
    />
  );
};
